import styled from 'styled-components'

type Props = {
  prefix?: string
  suffix?: string
  dynamicSuffix?: string
  dynamicSuffixClassName?: string
  subline?: string
  glue?: string
}

const Suffix = styled.div`
  @keyframes mark {
    0% {
      -webkit-clip-path: inset(0 100% 0 0);
      clip-path: inset(0 100% 0 0);
    }
    100% {
      -webkit-clip-path: inset(0 0 0 0);
      clip-path: inset(0 0 0 0);
    }
  }

  position: relative;
  z-index: 1;
  &:before {
    content: '';
    display: block;
    width: calc(100% + 10px);
    height: 100%;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='266.576' height='77.546'%3E%3Cdefs%3E%3CclipPath id='a'%3E%3Cpath fill='%23e3ff00' d='M0 0h264.352v68.362H0z' data-name='Rechteck 53'/%3E%3C/clipPath%3E%3C/defs%3E%3Cg data-name='Komponente 28 – 319' style='mix-blend-mode:multiply;isolation:isolate'%3E%3Cg data-name='Gruppe 377' style='mix-blend-mode:multiply;isolation:isolate'%3E%3Cg clip-path='url(%23a)' data-name='Gruppe 376' transform='rotate(-2 263.52 4.615)'%3E%3Cpath fill='%23e3ff00' d='M4.842.036S59.774 5.179 89.159 6.45s107.158 1.849 119.928 3.785 53.672 3.556 53.672 3.556l-2.333 56.017s-74.957-6.871-91.6-6.994-94.4-.439-123.534-3.024c-7.053-.624-37.62-3.173-43.379-3.479Z' data-name='Pfad 376'/%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    position: absolute;
    left: -5px;
    top: -2.5px;
    z-index: -1;
    animation-name: mark;
    animation-duration: 0.75s;
  }
`

const HeadlineSplit: React.FC<Props> = ({ prefix, suffix, dynamicSuffix, subline, glue, dynamicSuffixClassName = '' }) => {
  return (
    <div>
      <div className="flex flex-wrap gap-2 items-end">
        {!!prefix && <div className="text-xl leading-8 font-light text-black">{prefix}</div>}
        {!!suffix && <Suffix className="text-xl leading-9 font-swear-display text-black">{suffix}</Suffix>}
        {!!dynamicSuffix && (
          <div className={`text-xl leading-8 text-black text-nowrap ${dynamicSuffixClassName}`}>{` ${glue || '-'} ${dynamicSuffix}`}</div>
        )}
      </div>
      {subline && <div className="mt-1 text-black">{subline}</div>}
    </div>
  )
}

export default HeadlineSplit
